// extracted by mini-css-extract-plugin
export default {"SubmitBtn":"reviewButton_SubmitBtn__vH6Fj"};